// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Title,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title);

// const BarGraph = () => {
//   const data = {
//     labels: ["3 Jan", "4 Jan", "5 Jan", "6 Jan", "7 Jan"],
//     datasets: [
//       {
//         label: "Actual Orders",
//         data: [10000, 33500, 25000, 30000, 27000],
//         backgroundColor: "rgba(54, 162, 235, 1)",
//         borderRadius: 5,
//         barPercentage: 0.5,
//       },
//       {
//         label: "Projected Orders",
//         data: [40000, 40000, 35000, 38000, 36000],
//         backgroundColor: "rgba(54, 162, 235, 0.3)",
//         borderRadius: 5,
//         barPercentage: 0.5,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `₹${context.raw.toLocaleString()}`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return `₹${value.toLocaleString()}`;
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ width: "60%", margin: "0 auto" }}>
//       <h3 className="text-center font-bold text-lg">Last 5 Days Order</h3>
//       <Bar data={data} options={options} />
//     </div>
//   );
// };

// export default BarGraph;
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title, Legend);




// const BarGraph = ({ dataList }) => {
//   console.log("dataList", dataList);

//   // Find the max value across both actual and expected orders
//   const maxOrders = Math.max(
//     ...dataList.flatMap(i => [i.total_orders, i.expected_orders || 0])
//   );

//   const data = {
//     labels: dataList.map(i => i.order_date),
//     datasets: [
//       {
//         label: "Actual Orders",
//         data: dataList.map(i => i.total_orders),
//         backgroundColor: "rgba(54, 162, 235, 1)", // Blue
//         borderRadius: 5,
//         barPercentage: 0.5,
//       },
//       {
//         label: "Expected Orders",
//         data: dataList.map(i => i.expected_orders || 0), // Default to 0 if not present
//         backgroundColor: "rgba(255, 99, 132, 1)", // Red
//         borderRadius: 5,
//         barPercentage: 0.5,
//       },
//     ],
//   };




const BarGraph = ({ dataList }) => {


  const maxOrders = Math.max(
    ...dataList.flatMap(i => [i.total_orders, i.rejected_orders])
  );

  const data = {
    labels: dataList.map(i => i.order_date),
    datasets: [
      {
        label: "Accepted Orders",
        data: dataList.map(i => i.accepted_orders),
        backgroundColor: "rgba(54, 162, 235, 1)", // Blue
        borderRadius: 5,
       
//         barPercentage: 1,
// categoryPercentage: 0.6,
      },
      {
        label: "Rejected Orders",
        data: dataList.map(i => i.rejected_orders),
        backgroundColor: "rgb(212, 40, 40)", // Red
        borderRadius: 5,
//        barPercentage: 1,
// categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw.toLocaleString()}`;
          },
        },
      },
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: maxOrders + 5,
        ticks: {
          callback: function (value) {
            return `${value.toLocaleString()}`;
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div style={{ width: "60%", margin: "0 auto", height: "20%" }}>
      <h3 className="text-center font-bold text-lg">Last 5 Days Order</h3>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarGraph;

